// extracted by mini-css-extract-plugin
export default {"content":"RenewalNotice_content__Ys5Le","title":"RenewalNotice_title__ctCcB","indexLinks":"RenewalNotice_indexLinks__eP4aY"};